import { OptionItem } from "@interface48/api";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import React from "react";
import { processValue } from "../utils";
import { WidgetProps } from "./models";

interface RadioWidgetProps extends WidgetProps<string | number | boolean | Array<string | number>> {
  options: {
    enumOptions?: Array<OptionItem<string | number | boolean>>;
    inline?: boolean;
    emptyValue?: any;
  };
}

export const RadioWidgetComponent = (props: RadioWidgetProps) => {
  const { id, schema, options, value, disabled, label, required, onChange, onBlur, onFocus } = props;
  const { inline } = options;
  let { enumOptions } = options;

  if (!enumOptions) {
    throw Error("enumOptions must be specified.");
  }

  // Generating a unique field name to identify this set of radio buttons
  const name = Math.random().toString();

  // If this is a boolean field, and options have not been explicitly defined, overwrite the default RJSF options
  // (i.e. lower-cased 'no' and 'yes')
  if (schema.type === "boolean" && !schema.enum) {
    enumOptions = [
      { value: true, label: "Yes" },
      { value: false, label: "No" },
    ];
  }

  // If an (Unspecified) option has not yet been added, prepend it to the front of the list if the field is not
  // required (i.e. so that the user can revert to an unspecified value)...
  if (!required && enumOptions.findIndex(o => o.value === "") === -1) {
    enumOptions.unshift({ value: "", label: "(Unspecified)" });
  }

  const handleChange = (event: any, changeValue: any) => {
    const processedValue = processValue(changeValue, schema.type, required, options && options.emptyValue);
    onChange(processedValue);
  };

  const handleBlur =
    onBlur &&
    ((event: any) => {
      const processedValue = processValue(event.target.value, schema.type, required, options && options.emptyValue);
      onBlur(id, processedValue);
    });

  const handleFocus =
    onFocus &&
    ((event: any) => {
      const processedValue = processValue(event.target.value, schema.type, required, options && options.emptyValue);
      onFocus(id, processedValue);
    });

  return (
    <RadioGroup
      aria-label={label}
      name={name}
      value={value == null ? "" : value + ""}
      onChange={handleChange}
      onBlur={handleBlur}
      onFocus={handleFocus}
      style={{ flexDirection: inline ? "row" : "column", marginTop: inline ? "12px" : "14px" }}
    >
      {enumOptions.map((option: { value: any; label: string }, i: number) => {
        return (
          <FormControlLabel
            key={i}
            name={name}
            value={option.value + ""}
            disabled={disabled}
            label={option.label}
            control={<Radio />}
          />
        );
      })}
    </RadioGroup>
  );
};

export const RadioWidget = RadioWidgetComponent;
